export default __webpack_public_path__ + "3fce0e3cd63a535bb4285279f7d8e1b7.svg";